
// @ts-nocheck


export const localeCodes =  [
  "fr",
  "en",
  "de",
  "it",
  "es"
]

export const localeLoaders = {
  "fr": [{ key: "../lang/fr.json", load: () => import("../lang/fr.json" /* webpackChunkName: "locale__app_lang_fr_json" */), cache: true }],
  "en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__app_lang_en_json" */), cache: true }],
  "de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__app_lang_de_json" */), cache: true }],
  "it": [{ key: "../lang/it.json", load: () => import("../lang/it.json" /* webpackChunkName: "locale__app_lang_it_json" */), cache: true }],
  "es": [{ key: "../lang/es.json", load: () => import("../lang/es.json" /* webpackChunkName: "locale__app_lang_es_json" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "fr",
      "language": "fr-FR",
      "name": "Français",
      "files": [
        "/app/lang/fr.json"
      ]
    },
    {
      "code": "en",
      "language": "en-US",
      "name": "English",
      "files": [
        "/app/lang/en.json"
      ]
    },
    {
      "code": "de",
      "language": "de-DE",
      "name": "Deutsch",
      "files": [
        "/app/lang/de.json"
      ]
    },
    {
      "code": "it",
      "language": "it-IT",
      "name": "Italiano",
      "files": [
        "/app/lang/it.json"
      ]
    },
    {
      "code": "es",
      "language": "es-ES",
      "name": "Español",
      "files": [
        "/app/lang/es.json"
      ]
    }
  ],
  "defaultLocale": "fr",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "lang/",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "printags_locale",
    "cookieSecure": false,
    "fallbackLocale": "en",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "fr",
    "language": "fr-FR",
    "name": "Français",
    "files": [
      {
        "path": "/app/lang/fr.json"
      }
    ]
  },
  {
    "code": "en",
    "language": "en-US",
    "name": "English",
    "files": [
      {
        "path": "/app/lang/en.json"
      }
    ]
  },
  {
    "code": "de",
    "language": "de-DE",
    "name": "Deutsch",
    "files": [
      {
        "path": "/app/lang/de.json"
      }
    ]
  },
  {
    "code": "it",
    "language": "it-IT",
    "name": "Italiano",
    "files": [
      {
        "path": "/app/lang/it.json"
      }
    ]
  },
  {
    "code": "es",
    "language": "es-ES",
    "name": "Español",
    "files": [
      {
        "path": "/app/lang/es.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
